import React, { useCallback, useState } from "react";
import { Form } from "react-bootstrap";
import SupplierSearch from "@components/SupplierSearch";
import { LocationSearch } from "@components/Select";
import { Region } from "@api/getregions";
import { SelectedSupplier } from "@components/Supplier/AddSupplier";
import scss from "./BookedVenue.module.scss";
import { useFormContext } from "react-hook-form";

const VALUE_YES = "Yes";
const VALUE_NO = "No";
const RADIO_NAME = "wedding-booked";

export interface IBookedResult {
    venueSupplierId?: number;
    venueSupplierName?: string;
    regionName?: string;
}


const BookedVenue = () => {
    const { register, setValue, formState: { errors }, watch } = useFormContext();
    const regionId = watch("venue.regionId");
    const venueSupplierName = watch("venue.venueName");
    const booked = watch("venue.haveVenue");
    const [currentRegion, setCurrentRegion] = useState<Region | null>({
        Id: regionId ?? 0,
        Name: '',
        ShortName: '',
        Slug: '',
    });

    const handleRegionChange: React.Dispatch<React.SetStateAction<Region | null>> = (newRegion) => {
        if (newRegion && typeof newRegion !== 'function') {
            setCurrentRegion(newRegion);
            setValue("venue.regionId", newRegion.Id);
            setValue("venue.regionName", newRegion.Name);
        }
    };

    const handleVenueChange = useCallback((supplier: SelectedSupplier | null) => {
        setValue("venue.venueId", !!supplier ? Number(supplier.Id) : 0);
        setValue("venue.venueName", !!supplier ? supplier.Name : '');
    }, [setValue]);

    return (
        <>
            <div className="d-flex align-items-center">
                <Form.Label className={'ms-1 me-3 mt-2 small d-inline-block text-shade'}>Have you booked your wedding venue?</Form.Label>
                <div className="d-flex">
                    <Form.Check
                        inline
                        id={`${RADIO_NAME}-yes`}
                        label={VALUE_YES}
                        value={VALUE_YES}
                        type={'radio'}
                        className={scss.radio}
                        data-testid="venue-booked-yes"
                        {...register("venue.haveVenue", {
                            required: "Please select an option",
                        })}
                    />
                    <Form.Check
                        inline
                        id={`${RADIO_NAME}-no`}
                        label={VALUE_NO}
                        value={VALUE_NO}
                        type={'radio'}
                        className={scss.radio}
                        data-testid="venue-booked-no"
                        {...register("venue.haveVenue", {
                            required: "Please select an option",
                        })}
                    />
                </div>
            </div>
            {booked === VALUE_YES && <SupplierSearch
                categoryName={'Venue'}
                categorySlug={'WeddingVenues'}
                placeholder={'Name of the venue you\'ve booked'}
                isFocus={false}
                hideBackground={true}
                hideAfterSelect={true}
                callOnClear={true}
                defaultValue={venueSupplierName}
                formElementHeight={true}
                handleSaveSupplier={handleVenueChange}
            />}
            {booked === VALUE_NO && <LocationSearch
                customDropdownClass={'w-100'}
                initialRegionId={Number(regionId)}
                currentRegion={currentRegion}
                setCurrentRegion={handleRegionChange}
            />}
            {errors.venue && <div className="text-danger ps-1" style={{ fontSize: '0.75rem' }}>{errors.venue.message as string}</div>}
        </>
    );
};

export default BookedVenue;